import React from "react";
import { Link } from "react-router-dom";
import BasePage from "../../base/BasePage";
import InputFactory from "../../components/InputFactory";
import { resetPasswordUseCase } from "../../usecases/user";
import ForgotPresenter from "./ForgotPresenter";
import PublicAuthFrame from "./PublicAuthFrame";
import withRouter from "../../withRouter";

class ForgotPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new ForgotPresenter(this, resetPasswordUseCase());
    this.state = { email: "", circular: false };
  }

  onResetPassword(e) {
    e.preventDefault();
    this.presenter.forgotPassword(this.state.email);
  }

  onChange(value) {
    this.setState({ email: value });
  }

  render() {
    return (
      <PublicAuthFrame title="Forgot Password?">
        <p className="text-muted mb-3">
          Enter your email or username and we'll send you a link to reset your
          password.
        </p>
        <form onSubmit={this.onResetPassword.bind(this)}>
          <label className="form-label" style={{ fontSize: "16px" }}>
            Email Address / Username
          </label>
          <InputFactory
            className="form-control mb-3"
            type="String"
            field="email"
            required
            placeholder="Email Address / Username"
            onChange={this.onChange.bind(this)}
          />
          <div className="text-center">
            <button
              type="submit"
              className="w-100 btn text-white"
              style={{ backgroundColor: "#29457c", borderRadius: "5px" }}
              disabled={this.state.circular}
            >
              {this.state.circular ? "Please wait..." : "SEND"}
            </button>
          </div>
        </form>
        <div className="text-center mt-3">
          <Link to="/signin" className="btn btn-link link-dark">
            <i className="bi bi-arrow-left me-2"></i>Back to sign in
          </Link>
        </div>
      </PublicAuthFrame>
    );
  }
}

export default withRouter(ForgotPage);
